import { render, staticRenderFns } from "./SalariedPayrun.vue?vue&type=template&id=2e0fb48a&scoped=true"
import script from "./SalariedPayrun.vue?vue&type=script&lang=js"
export * from "./SalariedPayrun.vue?vue&type=script&lang=js"
import style0 from "./SalariedPayrun.vue?vue&type=style&index=0&id=2e0fb48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0fb48a",
  null
  
)

export default component.exports